

import { Typography, Button, Box } from "@mui/material";
import successImage from "../../assets/success.gif";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const BASE_URL = import.meta.env.VITE_BASE_URL;

type sessionData = {
  status: string;
  name: string;
  email: string;
  mode: string;
  sessionId: string;
  url: string;
};
const Success = () => {
  const [searchParams] = useSearchParams();
  const session_id = searchParams.get("session_id"); // Get the session value
  const [sessionDetails, setSessionDetails] = useState<sessionData | null>(
    null
  );

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = ""; // Required for Chrome
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // Getting location lists
  // useEffect(() => {

  //   let called = false; // Flag to avoid duplicate API calls
  //   const getUserDetail = async () => {
  //     if (called) return; // Already called once
  //     called = true;

  //     try {
  //       const response = await axios.get(
  //         `${API_BASE_URL}payment/payment-status/${session_id}`
  //       );
  //       if (response.status >= 200 && response.status <= 300) {
  //         setSessionDetails(response.data.data);
  //         window.history.replaceState(
  //           {},
  //           document.title,
  //           window.location.pathname
  //         );
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //   };
  //   if (session_id) {
  //     getUserDetail();
  //   } // Passing the payload as an argument
  // }, [session_id]);

  const calledRef = useRef(false); // useRef to persist value

useEffect(() => {
  const getUserDetail = async () => {
    if (calledRef.current) return; // Prevent duplicate call
    calledRef.current = true;

    try {
      const response = await axios.get(
        `${API_BASE_URL}payment/payment-status/${session_id}`
      );
      if (response.status >= 200 && response.status <= 300) {
        setSessionDetails(response.data.data);
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  if (session_id) {
    getUserDetail();
  }
}, [session_id]);



  return (
    <>
      {/* {sessionDetails?.status === "paid" ? ( */}
      {sessionDetails?.status === "paid" ? (
        <>
          <Box
            sx={{
              backgroundColor: "#c7ffdb",
              width: "100vw",
              height: "100vh",
              display: "inline-block",
              alignContent: "center",
            }}
          >
            <Box
              textAlign="center"
              mt={0}
              sx={{
                backgroundColor: "#fff",
                width: "fit-content",
                margin: "0 auto",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 2px 8px #adadad",
              }}
            >
              <>
                <Box
                  component="img"
                  src={successImage}
                  alt="Success"
                  width= "100px"
                    height= "100px"
                  // sx={{
                  //   width: "100px",
                  //   height: "100px",
                  // }}
                ></Box>
                <Box
                  sx={{
                    color: "green",
                    fontWeight: "bold",
                    fontSize: "24px",
                    padding: "10px 0 ",
                  }}
                >
                  Payment Successful 🎉
                </Box>
                <Box sx={{ padding: "10px 0" }}>
                  <Typography variant="body1">
                    Hi, <b> {sessionDetails?.name}</b>
                  </Typography>
                  <Typography variant="body1">
                    Your subscription process has been completed successfully.
                    You are now accessing our <b>{sessionDetails?.mode}</b>.
                  </Typography>
                  <Typography variant="body1">
                    Your login details have been sent to your registered email
                    ID <b> {sessionDetails?.email}</b>.
                  </Typography>
                  <Typography variant="body1">
                    Thank you for choosing us!"
                  </Typography>
                </Box>

                <Box mt={2}>
                  <Button
                    component="a"
                    href={`${BASE_URL}login`}
                    variant="contained"
                    color="success"
                    sx={{ width: "fit-content" }}
                  >
                    Go to Home page
                  </Button>
                </Box>
              </>
            </Box>
          </Box>
        </>
      ) : 
      sessionDetails?.status === "unpaid" ? (
        <>
          <Box
            sx={{
              backgroundColor: "#c7ffdb",
              width: "100vw",
              height: "100vh",
              display: "inline-block",
              alignContent: "center",
            }}
          >
            <Box
              textAlign="center"
              mt={0}
              sx={{
                backgroundColor: "#fff",
                width: "fit-content",
                margin: "0 auto",
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 2px 8px #adadad",
              }}
            >
              <>
                <Box sx={{ fontSize: "50px" }}>⏳</Box>

                <Box
                  sx={{
                    color: "orange",
                    fontWeight: "bold",
                    fontSize: "24px",
                    padding: "10px 0",
                  }}
                >
                  Payment Pending
                </Box>
                <Box sx={{ padding: "10px 0" }}>
                  <Typography variant="body1">
                    Your subscription process is in progress. We are awaiting
                    confirmation of your payment.
                  </Typography>
                </Box>

                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="success"
                    //   onClick={onClose}
                    sx={{ width: "fit-content" }}
                    onClick={() => (window.location.href = sessionDetails?.url)} // Redirect to external domain
                  >
                    Go to Checkout
                  </Button>
                </Box>
              </>
            </Box>
          </Box>
        </>
      ) : (
        <>
        </>
      )}
    </>
  );
};

export default Success;
